export default __webpack_public_path__ + "static/montiara-430784cd94ce17cc8da6edc04360e80f.png";